import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  guestCart: [],
  userCart: [],
  totalQuantity: 0,
  subtotal:0,
  discount:0,
  deliveryFee:0,
  total: 0,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const { item, isGuest } = action.payload;
      console.log("DDDD",item,isGuest)
      const cart = isGuest ? state.guestCart : state.userCart;
     const existingItem = cart.find(cartItem => cartItem.prodGuId === item.prodGuId);
        console.log("guestcart",cart)
        
        if (existingItem) {
          // existingItem.quantity += 1;
          existingItem.quantity = item.quantity || existingItem.quantity + 1;
        } else {
          cart.push({ ...item, quantity:item.quantity|| 1 });
        }
    },
    calculateTotals: (state,action) => {
      state.subtotal = action.payload.subtotal ?? 0;
      state.discount = action.payload.discount ?? 0;
      state.totalPrice = action.payload.totalPrice ?? 0;
  
    },
    removeFromCart: (state, action) => {
      const { prodGuId, isGuest } = action.payload;

      if (isGuest) {
        state.guestCart = state.guestCart.filter((item) => item.prodGuId !== prodGuId);
      } else {
      
        state.userCart = state.userCart.filter((item) => item.prodGuId !== prodGuId);
      }
     
    },

    clearCart: (state) => {
      state.userCart = [];
      state.subtotal = 0;
      state.totalQuantity = 0;
      state.discount = 0;
      state.deliveryFee = 0;
      state.total = 0;
      state.guestCart=[];
    
    },
  },
});
export const { addToCart, removeFromCart, clearCart,  calculateTotals } = cartSlice.actions;
export default cartSlice.reducer;



